import { Text } from "@minuthq/meatball-ui-react"

import { useTranslate } from "src/i18n/useTranslate"
import { textCharacterCount, textWordCount } from "src/utils/genericUtil"

type TextCountProps = {
  value: string
  maxCharacters: number
  hideWordCount?: boolean
}

export function TextCount({
  value,
  maxCharacters,
  hideWordCount = false,
}: TextCountProps) {
  const { t, langKeys } = useTranslate()

  const wordCount = textWordCount(value)
  const characterCount = textCharacterCount(value)

  const isOverLimit = characterCount > maxCharacters

  return (
    <Text
      variant="bodyXS"
      color={isOverLimit ? "emergency" : "secondary"}
      textAlign="right"
    >
      {!hideWordCount && (
        <span>
          {t(langKeys.words_count, {
            count: wordCount,
          })}{" "}
          &bull;{" "}
        </span>
      )}

      <span>
        {characterCount} / {maxCharacters} {t(langKeys.characters)}
      </span>
    </Text>
  )
}
